import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ExtensionEvent, Hort360GrowerProperty, Hort360PropertySummary, Meeting} from '../../../../functions/src/types';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {ApiService} from '../../services/api.service';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {LocalStorageService} from '@efaps/ngx-store';
import {MatTableDataSource} from '@angular/material/table';
import {DataService} from '../../services/data.service';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import defaultValues = RSDialog.defaultValues;
import {RSLoadingModalService} from '../../../libs/rsloading/rsloading.service';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";
import * as XLSX from "xlsx";
import * as moment from "moment";
import {AddMeetingComponent} from "../add-meeting/add-meeting.component";
import {ViewMeetingComponent} from "../view-meeting/view-meeting.component";
import {PropertyService} from "../../services/property.service";

@Component({
  selector: 'app-meetings',
  templateUrl: './meetings.component.html',
  styleUrls: ['./meetings.component.scss']
})
export class MeetingsComponent implements OnInit, OnDestroy {
  public isSearching = false;
  private meetings: Meeting[] = [];
  public searchResults: Meeting[] | null = null;
  private searchEvent = null;
  private lastSearch = null;
  @Input('searchTerm') public searchTerm = '';
  @Output('selected') selected = new EventEmitter<Meeting>();

  displayedColumns: string[] = ['date', 'topic', 'properties', 'attendees', 'edit'];
  dataSource = null;
  private dataSort = null;
  private dataPaginator = null;

  @ViewChild(MatSort) set sort(sort: MatSort) {
    this.dataSort = sort;
    if (this.dataSort && this.dataSource) {
      this.dataSource.sort = this.dataSort;
    }
  }

  @ViewChild(MatPaginator) set paginator(paginator: MatPaginator) {
    this.dataPaginator = paginator;
    if (this.dataPaginator && this.dataSource) {
      this.dataSource.paginator = this.dataPaginator;
    }
  }

  private meetingsSub: Subscription;

  constructor(
    private rsDialog: RSDialogService,
    private lsService: LocalStorageService,
    public dataService: DataService,
    private rsDialogService: RSDialogService,
    public loadingService: RSLoadingModalService,
    public fbDB: AngularFirestore,
    public propertyService: PropertyService,
    private route: ActivatedRoute
  ) {
    if (this.route.snapshot.params && this.route.snapshot.params.id) {
      console.log('route.snapshot.params.id', this.route.snapshot.params);
      this.searchTerm = this.route.snapshot.params.id;
    }
    this.meetingsSub = this.dataService.meetings.subscribe(v => {
      this.meetings = v;
      this.searchMeetings();
    });
  }

  public searchMeetings() {
    this.searchTerm = this.searchTerm.trim();
    const searchEvent = +new Date();
    this.searchEvent = searchEvent;
    this.lastSearch = this.searchTerm;
    this.lsService.set('meetingSearch', this.searchTerm);
    this.searchResults = null;
    this.isSearching = true;

    setTimeout(() => {
      try {
        if (searchEvent !== this.searchEvent) {
          return;
        }
        const lowerSearch = this.searchTerm.toLowerCase();
        this.searchResults = this.meetings
          .filter(m => {
            return !this.searchTerm ||
              (
                (m.id + '').toLowerCase().indexOf(lowerSearch) !== -1 ||
                (m.topic + '').toLowerCase().indexOf(lowerSearch) !== -1 ||
                (m.locationTown + '').toLowerCase().indexOf(lowerSearch) !== -1 ||
                (m.locationLga + '').toLowerCase().indexOf(lowerSearch) !== -1 ||
                (m.notes + '').toLowerCase().indexOf(lowerSearch) !== -1
              );
          });
        this.dataSource = new MatTableDataSource(this.searchResults);
        this.dataSource.sort = this.dataSort;
        this.dataSource.paginator = this.dataPaginator;
        this.isSearching = false;
      } catch (e) {
        console.error(e);
        this.rsDialog.showErrorDialog('Something went wrong. Please try again. ' + e.message);
        this.isSearching = false;
      }
    });
  }

  async selectMeeting(meeting: Meeting) {
    try {
      const attendees = await this.fbDB.collection(`meetings/${meeting.id}/attendees`).get().toPromise();
      const attendeeIds = attendees.docs.map(d => d.id + '');
      const selectedProperties = this.propertyService.getPropertySummaries(attendeeIds);

      const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, false);
      dialogOptions.title = meeting.topic || 'Meeting';
      dialogOptions.cancelable = true;
      dialogOptions.closeButton = true;
      dialogOptions.size = RSDialog.Size.LARGE;
      dialogOptions.style = RSDialog.Style.SUCCESS;

      // Add our custom component;
      dialogOptions.component = ViewMeetingComponent;

      // Use an old fashioned object to assign variable values to;
      const propertyAttendees: { [key: number]: number } = {};
      attendees.docs.forEach(d => propertyAttendees[d.id] = (d.data() || {} as any).total || 1);
      const oValues: { meeting: Meeting, properties: Hort360PropertySummary[], propertyAttendees: { [key: number]: number } } = {meeting, properties: selectedProperties, propertyAttendees};

      console.log('updateMeeting::: values:: ', oValues);
      dialogOptions.values = oValues;

      this.rsDialogService.showDialog(dialogOptions).then(() => {
      }, () => {
      });

    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. ' + e.message);
    }
  }

  ngOnInit(): void {
    this.searchTerm = this.lsService.get('meetingSearch') || '';
    this.searchMeetings();
  }

  async deleteMeeting(meetingId) {
    const bDelete = await this.rsDialogService.showConfirmDialog(
      'Are you sure you want to delete this meeting?',
      false,
      'Delete Meeting',
      RSDialog.Style.WARN
    );
    if (!bDelete) {
      return;
    }
    this.loadingService.show();
    try {
      await this.dataService.deleteMeeting(meetingId);
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. Please try again. ' + e.message);
    }
    this.loadingService.hide();
  }

  async downloadMeeting(meetingId) {
    console.log('downloadMeeting::: ', meetingId);

    // Wait for the results;
    this.loadingService.show();
    try {
      const meeting = this.dataService.meetings.value.find(c => c.id === meetingId);
      const attendees = await this.fbDB.collection(`${this.dataService.meetingsRef.ref.path}/${meeting.id}/attendees`).get().toPromise();
      const attendingProperties = attendees.docs.map(p => p.id);
      const getProperties = attendingProperties.map(p => this.propertyService.getProperty(p));
      function reflect(promise) {
        return promise.then(
          (v) => {
            return { status: 'fulfilled', value: v };
          },
          (error) => {
            return { status: 'rejected', reason: error };
          }
        );
      }
      const gotProperties = await Promise.all(getProperties.map(p => reflect(p[1])));
      const attendeeInfo = [];
      attendees.docs.forEach((a, i) => {
        const promise = gotProperties[i];
        const propertySummary: Hort360PropertySummary = getProperties[i][0] || {} as Hort360PropertySummary;
        let property: Hort360GrowerProperty = {} as Hort360GrowerProperty;
        if (promise.value) {
          property = promise.value || {};
        }

        attendeeInfo.push({
          propertyId: property?.id || propertySummary?.id || a.id,
          propertyAttendees: (a.data() || {} as any).total || 0,
          propertyAddress: propertySummary?.address || 'UNKNOWN',
          propertyCatchment: propertySummary?.catchment || 'UNKNOWN',

          growerId: propertySummary?.growerId || 'UNKNOWN',
          growerMobile: property?.mobile || '',
          growerPhone: property?.phone || '',
          growerABN: property?.abn || '',
          growerCompany: property?.company || '',
          growerEmailAddress: property?.emailaddress || '',
        });
      });

      // Build the WB
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(attendeeInfo);
      const safeName = (meeting.topic + ' Attendees').replace(/[\W_]+/g, '_').substr(0, 30);
      XLSX.utils.book_append_sheet(wb, ws, safeName);
      const result = XLSX.writeFile(wb, `Meeting-${safeName}-${moment().format('X')}.xlsx`); // Save to file
      console.log(result);
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. ' + (e.message ? e.message : e));
    }
    this.loadingService.hide();
  }

  async updateMeeting(meetingId) {
    console.log('updateMeeting::: ', meetingId);

    const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, true);
    dialogOptions.title = 'Meeting ';
    dialogOptions.cancelable = false;
    dialogOptions.closeButton = false;
    dialogOptions.size = RSDialog.Size.LARGE;
    dialogOptions.style = RSDialog.Style.SUCCESS;

    // Add our custom component;
    dialogOptions.component = AddMeetingComponent;

    // Use an old fashioned object to assign variable values to;
    const oValues: { meeting: Meeting, propertyAttendees: { [key: number]: number } } =
      {
        meeting: this.dataService.meetings.value.find(c => c.id === meetingId) || {} as Meeting,
        propertyAttendees: {}
      };

    console.log('updateMeeting::: values:: ', oValues);
    dialogOptions.values = oValues;

    this.rsDialogService.showDialog(dialogOptions).then(
      async (v) => {
        console.log(v, oValues);
        if (v === defaultValues.YES) {
          this.loadingService.show();

          try {
            const propertyAttendees = {};
            Object.keys(oValues.propertyAttendees).forEach(id => propertyAttendees[id] = oValues.propertyAttendees[id] || 0);
            await this.dataService.addUpdateMeeting(oValues.meeting, propertyAttendees);
          } catch (e) {
            this.rsDialogService.showErrorDialog('Something went wrong. Please try again. ' + e.message);
          }

          this.loadingService.hide();
          this.searchMeetings();
        }
      },
      (e: any) => console.error
    );
  }

  ngOnDestroy() {
    if (this.meetingsSub) {
      this.meetingsSub.unsubscribe();
    }
  }
}
